import { CONFIG, explorerAddr } from "../config.js";
import { esc } from "../ui.js";

export function mountSecurity(root) {
  const pid = CONFIG.programId;
  root.innerHTML = `
  <section class="doc">
    <p class="eyebrow">Security</p>
    <h1 class="display-md">Responsible disclosure</h1>
    <p class="lede">If you find a vulnerability in THE WATER WELL, please tell us privately first so it can be fixed
    before anyone's SOL is at risk.</p>

    <div class="doc-grid">
      <article class="panel doc-card">
        <h3>How to report</h3>
        <p>Send a direct message to <a href="https://x.com/WaterWellSol" target="_blank" rel="noopener">@WaterWellSol on X</a>.
        Include a short description, the affected instruction or account, and steps or a proof of concept that runs on
        devnet or a local validator.</p>
        <p class="muted">Please do not post details publicly until we confirm a fix or 30 days have passed since your report.</p>
      </article>
      <article class="panel doc-card">
        <h3>Scope</h3>
        <p>The on-chain program:</p>
        <p><a class="mono addr-link" href="${esc(explorerAddr(pid))}" target="_blank" rel="noopener">${esc(pid)}</a></p>
        <p class="muted">Out of scope: this website's styling, third-party wallets and RPC providers, social engineering,
        denial of service and token prices.</p>
      </article>
      <article class="panel doc-card doc-warn">
        <h3>Please don't exploit on mainnet</h3>
        <p>Do not test against mainnet wells or move funds that are not yours. Reproduce on devnet or a local validator.
        Acting in good faith and reporting promptly is what we ask.</p>
      </article>
      <article class="panel doc-card">
        <h3>No bounty promises</h3>
        <p>There is no formal bug bounty program. We will credit reporters who want credit, but we cannot promise any
        payment or reward.</p>
      </article>
    </div>
  </section>`;
  return () => {};
}
